import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, Box, CircularProgress, Alert
} from '@mui/material';
import { RocketLaunch as RocketLaunchIcon } from '@mui/icons-material';

const QuickSubmitDialog = ({ open, onClose, template, onConfirm }) => {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleConfirm = async () => {
    setSubmitting(true);
    setError('');
    try {
      await onConfirm(template);
      onClose();
    } catch (err) {
      setError(err.message || 'Failed to create observation');
    } finally {
      setSubmitting(false);
    }
  };

  if (!template) return null;

  const observatoryName = template.observatory_id?.name || template.observatory_id || 'Any observatory';
  const targetCount = template.targets?.length || 0;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <RocketLaunchIcon color="primary" />
        Quick Submit
      </DialogTitle>
      <DialogContent>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <Typography variant="body1" gutterBottom>
          Create an observation from <strong>{template.name}</strong>?
        </Typography>
        <Box sx={{ mt: 2, p: 2, bgcolor: 'background.default', borderRadius: 1 }}>
          <Typography variant="body2" color="text.secondary">
            Observatory: {observatoryName}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Targets: {targetCount}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Type: {template.observation_type || 'flexible'}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Priority: {template.priority || 5}
          </Typography>
          {template.estimated_duration_minutes > 0 && (
            <Typography variant="body2" color="text.secondary">
              Est. Duration: {template.estimated_duration_minutes} min
            </Typography>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={submitting}>Cancel</Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          disabled={submitting}
          startIcon={submitting ? <CircularProgress size={16} /> : <RocketLaunchIcon />}
        >
          {submitting ? 'Creating...' : 'Create Observation'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default QuickSubmitDialog;
